import React, { Component } from "react";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import Loader from "../../utils/loader";
import { withRouter } from "react-router-dom";
import TripDetailsTile from "../../components/tiles/tripDetailsTile";
import "./tripDetails.scss";
import PassengerDetailsTile from "../../components/tiles/passengerDetailsTile";
import BottomDrawer from "../../components/Layout/bottomDrawer";
import AssignDriverForm from "../../components/assignDriverForm/assignDriverForm";
import MidScreenPopUp from "../../components/Layout/midScreenPopUp";
import { Fetch } from "../../utils/fetch";
import MarshalDetailsMweb from "../../components/marshalDetailsMweb";
import jwt from "../../utils/jwt";
import { tracerUrl } from "../../config";
class TripDetails extends Component {
  state = {
    loading: true,
    isTrackBusLoading: false,
    isMobile: false,
    showSideMenu: false,
    isBottomDrawerOpen: false,
    showPopUp: false,
    rcNumber: "",
    driverMobileNo: "",
    driverName: "",
    isDriverAssigned: false,
    assignedTripDetails: {},
    marshalIdToBookingIdMap: {},
    bookingIdMap: {},
    tripIdToMarshalIdMap: {},
  };

  async componentDidMount() {
    try {
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobile = regex.test(navigator.userAgent);
      const params = new URLSearchParams(this.props.location.search);
      const tripId = params.get("_id");

      const path = `/cabOperator/trip/details?tripId=${tripId}`;
      const options = { method: "get" };

      const assignedTripDetails = await Fetch(path, options);

      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);

      if (assignedTripDetails === "error") {
        this.setState({
          loading: false,
          showPopUp: true,
          assignedTripDetails,
          isMobile,
          loggedInMobileNo: decodedToken.mobileNo,
        });
      } else {
        const boaredCoreBookings = [];
        if (assignedTripDetails && assignedTripDetails.length > 0) {
          assignedTripDetails.forEach((trip) => {
            if (trip.boaredCoreBooking && trip.boaredCoreBooking.length > 0) {
              trip.boaredCoreBooking.forEach((booking) => {
                boaredCoreBookings.push(booking);
              });
            }
          });
        }

        // Structuring maps
        const marshalIdToBookingIdMap = {}; // { tripId: { marshalId: [bookings] } }
        const bookingIdMap = {};
        const tripIdToMarshalIdMap = {};

        assignedTripDetails.forEach((trip) => {
          const tripId = trip.id;
          const tripMarshalMap = {};
          const marshalIdsInThisTrip = new Set();

          if (trip.boaredCoreBooking && trip.boaredCoreBooking.length > 0) {
            trip.boaredCoreBooking.forEach((boardedBooking) => {
              const { boardedLegMarshalDetails, bookingId } = boardedBooking;
              const normalizedBookingId = String(bookingId);

              if (boardedLegMarshalDetails && normalizedBookingId) {
                const marshalId = boardedLegMarshalDetails.busHostId;

                if (!tripMarshalMap[marshalId]) {
                  tripMarshalMap[marshalId] = [];
                }

                tripMarshalMap[marshalId].push({
                  bookingId: normalizedBookingId,
                  boardedLegMarshalDetails,
                });

                marshalIdsInThisTrip.add(marshalId);
              }
            });
          }

          // Always assign trip entry even if empty
          marshalIdToBookingIdMap[tripId] = tripMarshalMap;

          if (marshalIdsInThisTrip.size > 0) {
            tripIdToMarshalIdMap[tripId] = Array.from(marshalIdsInThisTrip);
          }

          if (trip.bookings && trip.bookings.length > 0) {
            trip.bookings.forEach((booking) => {
              if (booking && booking._id) {
                bookingIdMap[String(booking._id)] = booking;
              }
            });
          }
        });

        this.setState({
          loading: false,
          isMobile,
          rcNumber: assignedTripDetails[0].rcNumber,
          driverMobileNo: assignedTripDetails[0].driverMobileNo,
          driverName: assignedTripDetails[0].driverName,
          assignedTripDetails: assignedTripDetails[0],
          marshalIdToBookingIdMap,
          bookingIdMap,
          loggedInMobileNo: decodedToken.mobileNo,
          tripIdToMarshalIdMap,
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  toggleBottomDrawer = (assignedDriverDetails) => {
    this.setState((prevState) => ({
      isBottomDrawerOpen: !prevState.isBottomDrawerOpen,
    }));
    if (assignedDriverDetails) {
      this.setState({
        rcNumber: assignedDriverDetails.vehicleDetails.rc,
        driverMobileNo: assignedDriverDetails.driverDetails.mobileNo,
        driverName: assignedDriverDetails.driverDetails.name,
      });
    }
  };

  togglePopUp = (isSuccessFul) => {
    this.setState((prevState) => ({
      showPopUp: !prevState.showPopUp,
      isDriverAssigned: isSuccessFul,
    }));

    // Redirect to "/trips" if pop-up was shown due to invalid trip details
    if (this.state.assignedTripDetails === "error") {
      this.props.history.push("/trips");
    }
  };
  fetchCoreTrip = async (connectingBookingCode, cabServiceType) => {
    const url = `/cabOperator/tripDetails/${connectingBookingCode}/${cabServiceType}`;

    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (response) {
      return response;
    } else {
      return [];
    }
  };

  openTrackPage = async (bookingsWithMarshal) => {
    if (this.state.isTrackBusLoading) return; // prevent double click

    this.setState({ isTrackBusLoading: true });

    try {
      const bookingDetailsForTrack = bookingsWithMarshal;
      const trip = await this.fetchCoreTrip(
        bookingDetailsForTrack.connectingBookingCode,
        bookingDetailsForTrack.cabServiceType,
      );
      let cityId = null;
      if (bookingDetailsForTrack.cabServiceType === "LASTMILE") {
        cityId = bookingDetailsForTrack.fromCityId;
      } else if (bookingDetailsForTrack.cabServiceType === "FIRSTMILE") {
        cityId = bookingDetailsForTrack.toCityId;
      }
      let url = `${tracerUrl}cabsTracking/${trip}/${cityId}`;
      this.props.history.push("/track-bus", {
        trackUrl: url,
      });
    } catch (err) {
      console.log("Error fetching tracking details: ", err);
      // Optionally, show an error pop-up here}
    } finally {
      this.setState({ isTrackBusLoading: false });
    }
  };

  render() {
    const {
      showSideMenu,
      isMobile,
      loading,
      isBottomDrawerOpen,
      showPopUp,
      rcNumber,
      driverMobileNo,
      driverName,
      isDriverAssigned,
      assignedTripDetails,
      isTrackBusLoading,
    } = this.state;
    let active = 6;
    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    }

    return isMobile && assignedTripDetails !== "error" ? (
      <div className="container">
        <MobileMainHeader
          toggleSideMenu={this.toggleSideMenu}
          hasSubHeader={true}
        />

        {showSideMenu ? (
          <MenuSlideDrawer
            toggleSideMenu={this.toggleSideMenu}
            showSideMenu={showSideMenu}
            isMobile={isMobile}
          >
            <SideMenu active={active} toggleSideMenu={this.toggleSideMenu} />
          </MenuSlideDrawer>
        ) : null}
        <TripDetailsTile index={0} tripData={assignedTripDetails} />

        {driverMobileNo && driverName && rcNumber ? (
          <div className="driverDetailsContainer">
            <div className="assignmentStatus">
              <div className="status">
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/greentick.svg"
                  alt="driver assigned"
                />
                <span>Assigned</span>
              </div>
              {assignedTripDetails.startTime + 14400000 > Date.now() ? ( // 14400000: 4hours
                <div
                  className="editDetails"
                  onClick={() => this.toggleBottomDrawer()}
                >
                  <span>Edit Details</span>
                </div>
              ) : null}
            </div>
            <div className="driverDetails">
              <div className="info">
                <div className="text">
                  <span>{`RC: ${rcNumber}`}</span>
                </div>
                <div className="text">
                  <span>{`Mobile: ${driverMobileNo}`}</span>
                </div>
              </div>
              <div className="info">
                <div className="text">
                  <span>{`Name: ${driverName}`}</span>
                </div>
              </div>
            </div>
          </div>
        ) : assignedTripDetails.startTime + 14400000 > Date.now() ? ( // 14400000: 4hrs
          <div className="assignDriverButton">
            <button onClick={() => this.toggleBottomDrawer()}>
              Assign Driver
            </button>
          </div>
        ) : null}

        {/* Marshal wise grouped rendering or fallback */}
        {(() => {
          const tripId = assignedTripDetails.id;
          const marshalMap = this.state.marshalIdToBookingIdMap?.[tripId] || {};
          const marshalIds = this.state.tripIdToMarshalIdMap?.[tripId] || [];

          const confirmedBookings =
            assignedTripDetails.bookings?.filter(
              (booking) => booking.status === "CONFIRMED",
            ) || [];

          if (marshalIds.length > 0) {
            // Case 1 or 2: some marshal(s) present
            return (
              <>
                {/* Render bookings grouped by marshal */}
                {marshalIds.map((marshalId, marshalIndex) => {
                  const bookingsWithMarshal = marshalMap[marshalId];
                  const marshalDetails =
                    bookingsWithMarshal?.[0]?.boardedLegMarshalDetails || {};

                  return (
                    <div
                      className="marshalAndPassengerCardWrapper"
                      key={`marshal-${marshalId}`}
                    >
                      <MarshalDetailsMweb
                        connectingMarshal={marshalDetails}
                        index={marshalIndex}
                      />

                      <div className="label">
                        <span className="text">
                          {marshalDetails.name
                            ? `Passengers under marshal ${marshalDetails.name}`
                            : "Marshal Details: N.A"}
                        </span>
                      </div>

                      {bookingsWithMarshal.map(({ bookingId }) => {
                        const booking = this.state.bookingIdMap?.[bookingId];
                        if (!booking || booking.status !== "CONFIRMED")
                          return null;

                        return (
                          <PassengerDetailsTile
                            key={booking._id}
                            bookingData={booking}
                            startTime={assignedTripDetails.startTime}
                            isTrackBusLoading={isTrackBusLoading}
                            openTrackPage={() => this.openTrackPage(booking)}
                          />
                        );
                      })}
                    </div>
                  );
                })}

                {/* Case 2: Some bookings not mapped to marshal */}
                {confirmedBookings
                  .filter((booking) => {
                    return !marshalIds.some((marshalId) =>
                      marshalMap[marshalId]?.some(
                        (entry) => entry.bookingId === booking._id,
                      ),
                    );
                  })
                  .map((booking, index, arr) =>
                    index === 0 ? (
                      <div
                        key="fallback-na-group"
                        className="marshalAndPassengerCardWrapper"
                      >
                        <div className="marshalLabel">
                          <span className="marshalText">
                            Marshal Details: N.A
                          </span>
                        </div>

                        <PassengerDetailsTile
                          bookingData={booking}
                          startTime={assignedTripDetails.startTime}
                          openTrackPage={() => this.openTrackPage(booking)}
                        />

                        {arr.slice(1).map((b) => (
                          <PassengerDetailsTile
                            key={b._id}
                            bookingData={b}
                            startTime={assignedTripDetails.startTime}
                            openTrackPage={() => this.openTrackPage(b)}
                          />
                        ))}
                      </div>
                    ) : null,
                  )}
              </>
            );
          } else if (confirmedBookings.length > 0) {
            // Case 3: no marshal mapping at all
            return (
              <div className="marshalAndPassengerCardWrapper">
                <div className="marshalLabel">
                  <span className="marshalText">Marshal Details: N.A</span>
                </div>
                {confirmedBookings.map((booking) => (
                  <PassengerDetailsTile
                    key={booking._id}
                    bookingData={booking}
                    startTime={assignedTripDetails.startTime}
                    openTrackPage={() => this.openTrackPage(booking)}
                  />
                ))}
              </div>
            );
          } else {
            return null; // No confirmed bookings at all
          }
        })()}

        {isBottomDrawerOpen ? (
          <BottomDrawer
            heading="Assign a driver"
            isOpen={isBottomDrawerOpen}
            onClose={this.toggleBottomDrawer}
          >
            <AssignDriverForm
              tripData={assignedTripDetails}
              loggedInMobileNo={this.state.loggedInMobileNo}
              onCloseDrawer={this.toggleBottomDrawer}
              togglePopUp={this.togglePopUp}
              driverMobileNo={driverMobileNo}
              driverName={driverName}
              rcNumber={rcNumber}
            />
          </BottomDrawer>
        ) : null}

        {showPopUp && isDriverAssigned ? (
          <MidScreenPopUp
            imageUrl="https://d1flzashw70bti.cloudfront.net/original/images/optdash/popup/greentick.svg"
            text="Assignment Successful"
            subText="Trip has been successfully assigned to driver."
            buttonText="Ok"
            onClose={this.togglePopUp}
          />
        ) : showPopUp && !isDriverAssigned ? (
          <MidScreenPopUp
            imageUrl="https://d1flzashw70bti.cloudfront.net/original/images/optdash/crisis.svg"
            text="Assignment Failed"
            subText="Trip could not be assigned to driver."
            buttonText="Ok"
            onClose={this.togglePopUp}
          />
        ) : null}
      </div>
    ) : showPopUp && assignedTripDetails === "error" ? (
      <MidScreenPopUp
        imageUrl="https://d1flzashw70bti.cloudfront.net/original/images/optdash/crisis.svg"
        text="Trip doesn’t exist"
        subText="This trip has been reassigned and is not available anymore"
        buttonText="Go to Home"
        onClose={this.togglePopUp}
      />
    ) : null;
  }
}

export default withRouter(TripDetails);
